import { render, staticRenderFns } from "./ChatIA.vue?vue&type=template&id=59a07922&scoped=true&"
import script from "./ChatIA.vue?vue&type=script&lang=js&"
export * from "./ChatIA.vue?vue&type=script&lang=js&"
import style0 from "./ChatIA.vue?vue&type=style&index=0&id=59a07922&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59a07922",
  null
  
)

export default component.exports